import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import chartModel from "../../../models/charts/chart.model";
import 'CssFolder/chart.scss';

export default function TasksChartComponent() {

    let chart;
    let chartId = 'xychart';
    let data;
    let root;
    let xAxis;
    let yAxis;
    let legend;

    function initChart() {
        createChart();
        createAxes();
        createLegend();
        createSeries();
        loadData();
    }

    function createChart() {
        root?.dispose(); // dispose any pre-existing roots
        root = am5.Root.new(chartId);

        root.setThemes([
            am5themes_Animated.new(root)
        ]);

        chart = root.container.children.push(
            am5xy.XYChart.new(root, {
                panX: false,
                panY: false,
                wheelX: "none",
                wheelY: "none",
                layout: root.verticalLayout,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 15,
                paddingRight: 15,
            })
        );

        // Set chart title
        chart.topAxesContainer.children.push(am5.Label.new(root, {
            text: "Task Completion Status",
            fontSize: 16,
            fontWeight: "500",
            x: am5.p50,
            centerX: am5.p50,
            paddingTop: 0,
            paddingBottom: 10,
        }));

        // Set chart colors
        chart.get("colors").set("colors", [
            am5.color(0x0077C8), // Blue
            am5.color(0x00C3B2), // Teal
        ]);
    }

    function createAxes() {
        xAxis = chart.xAxes.push(
            am5xy.CategoryAxis.new(root, {
                categoryField: "type",
                renderer: am5xy.AxisRendererX.new(root, {
                    cellStartLocation: 0.2,
                    cellEndLocation: 0.8,
                    // minGridDistance: 30
                })
            })
        );

        let xRenderer = xAxis.get("renderer");

        xRenderer.grid.template.setAll({
            stroke: am5.color(0xFFFFFF),
            strokeWidth: 1
        });


        xRenderer.labels.template.setAll({
            fontSize: 12,
        });

        yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(root, {
                min: 0,
                maxPrecision: 0,
                renderer: am5xy.AxisRendererY.new(root, {})
            })
        );

        let yRenderer = yAxis.get("renderer");

        yRenderer.labels.template.setAll({
            fontSize: 12,
        });

        yRenderer.grid.template.setAll({
            stroke: am5.color(0xFFFFFF),
            strokeWidth: 1
        });

    }

    function makeSeries(fieldName, name) {
        var series = chart.series.push(am5xy.ColumnSeries.new(root, {
            name: name,
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: fieldName,
            categoryXField: "type"
        }));

        series.columns.template.setAll({
            tooltipText: "{name}, {categoryX}: {valueY}",
            width: am5.percent(100),
            tooltipY: 0
        });

        // Load data to series
        series.data.setAll(data);

        // Make stuff animate on load
        series.appear(1000, 100);

        legend.data.push(series);
    }

    function createSeries() {
        makeSeries("total", "Total");
        makeSeries("complete", "Completed");
    }

    function loadData() {
        // load data to xAxis
        xAxis.data.setAll(data);
    }

    function createLegend() {
        legend = chart.children.push(
            am5.Legend.new(root, {
                x: am5.p50,
                centerX: am5.p50,
                layout: root.horizontalLayout
            })
        );

        legend.labels.template.setAll({
            fontSize: 12,
            fontWeight: "300"
        });

        legend.data.setAll(chart.series.values);
    }

    return {
        oninit: function (vnode) {
            chartId += chartModel.generateID();
        },
        oncreate: function (vnode) {
            if (vnode.attrs.data) {
                // console.log('vnode.attrs.data: ', vnode.attrs.data);
                data = vnode.attrs.data;
                initChart();
            }
        },
        view: function (vnode) {
            return m('.chart', {
                id: chartId,
            });
        }
    }
}